import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-green-600 border border-green-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_2 = {
  key: 1,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = { class: "font-montserrat flex justify-center items-center relative min-w-screen min-h-screen py-[50px] px-[10px] bg-gray-50" }
const _hoisted_4 = { class: "w-full flex justify-center items-center flex-col relative py-[50px] md:px-[20px] px-[10px] max-w-[600px] border-2 border-gray-300 h-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-1xl mb-[20px] text-center font-bold" }, "Réinitialiser votre mot de passe", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "relative block" }
const _hoisted_8 = { class: "relative block" }
const _hoisted_9 = { class: "py-[15px] relative block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "uppercase"
}, "Password", -1)
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "pt-[25px] relative block" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] bg-gray-50 flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'resetPasswordConfirm',
  setup(__props) {

const pageTitle = ref('Reset Password | IronSecur');
const showPassword = ref(false);
const resetData = ref({
  uid: '', 
  token: '', 
  password: '',
});
const loading = ref(false);
const errorMessage = ref('');
const successMessage = ref('');
const router = useRouter();

onMounted(() => {
  resetData.value.uid = router.currentRoute.value.params.uid || ''; 
  resetData.value.token = router.currentRoute.value.params.token || '';
});


const isPasswordValid = (password: string) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return passwordRegex.test(password);
};

const requestPasswordReset = async () => {
  try {
    loading.value = true;
    // Vérification si le mot de passe respecte les critères
    if (!isPasswordValid(resetData.value.password)) {
      errorMessage.value = 'Le mot de passe doit contenir au moins 8 caractères avec majuscules, minuscules, chiffres et caractères spéciaux.';
      hideErrorMessageAfterDelay();
      return;
    }

    // Appel à l'API pour réinitialiser le mot de passe
    const response = await axiosInstance.post('/auth/users/reset_password_confirm/', {
      uid: resetData.value.uid, 
      token: resetData.value.token,
      new_password: resetData.value.password,
    });
    successMessage.value = 'Mot de passe changé avec succès';
    setTimeout(() => {
      router.push('/log'); 
    }, 2000);
  } catch (error) {
    errorMessage.value = 'Erreur lors de la demande de réinitialisation';
    hideErrorMessageAfterDelay();
  } finally {
    loading.value = false; 
  }
};


const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("form", {
          class: "relative w-full",
          onSubmit: _withModifiers(requestPasswordReset, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resetData.value.uid) = $event)),
              type: "hidden",
              id: "uid",
              class: "focus:border-gray-600 border p-[10px] border-gray-300 outline-none w-full",
              placeholder: "uid"
            }, null, 512), [
              [_vModelText, resetData.value.uid]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((resetData.value.token) = $event)),
              type: "hidden",
              id: "token",
              class: "focus:border-gray-600 border p-[10px] border-gray-300 outline-none w-full",
              placeholder: "token"
            }, null, 512), [
              [_vModelText, resetData.value.token]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: showPassword.value ? 'text' : 'password',
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((resetData.value.password) = $event)),
                placeholder: "Mot de passe",
                id: "password",
                class: "focus:border-gray-600 border p-[10px] border-gray-300 outline-none w-full"
              }, null, 8, _hoisted_12), [
                [_vModelDynamic, resetData.value.password]
              ]),
              _createElementVNode("i", {
                class: _normalizeClass(["password-toggle", showPassword.value ? 'fa fa-eye text-1xl absolute top-[15px] right-[15px]' : 'fa fa-eye-slash text-1xl absolute top-[15px] right-[15px]']),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value))
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "submit",
              disabled: loading.value,
              class: "p-[10px] bg-green-600 rounded-[5px] hover:bg-green-700 duration-100 text-sm font-bold cursor-pointer text-white outline-none w-full"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "Réinitialiser"))
            ], 8, _hoisted_14)
          ])
        ], 40, _hoisted_6)
      ])
    ]),
    _hoisted_17
  ], 64))
}
}

})